// extracted by mini-css-extract-plugin
module.exports = {"FollowMe":"FollowMe_FollowMe__ZSglU","twitter":"FollowMe_twitter__1S0nh","github":"FollowMe_github__15ghY","linkedin":"FollowMe_linkedin__UcNxT","email":"FollowMe_email__3bcji"};